import { Button } from 'components/Button';
import type IButton from 'components/Button/shared/types/button';
import React from 'react';
import type { ScrollSnapAutoplay } from 'scroll-snap-slider';
import useScrollSnapSliderContext from '../hooks/useScrollSnapSliderContext';

interface INavigationButton extends IButton {
    navType: 'next' | 'prev';
    slideAmount?: number;
}

export default function NavigationButton({ navType, slideAmount = 1, ...restProps }: INavigationButton) {
    const slider = useScrollSnapSliderContext();

    return (
        <Button
            onClick={() => {
                if (slider) {
                    (slider.plugins.get('ScrollSnapAutoplay') as ScrollSnapAutoplay)?.disableTemporarily();
                    const targetSlide = navType === 'prev' ? slider.slide - slideAmount : slider.slide + slideAmount;
                    slider.slideTo(targetSlide);
                }
            }}
            {...restProps}
        >
            {restProps.children}
        </Button>
    );
}
